import { PAYMENT_ENDPOINT } from '../../endpoints'
import axios from 'axios'

export async function addPayments(data) {
    const response = await axios.post(`${PAYMENT_ENDPOINT}`, data)
    
    return response?.data
}
